import ForgotPasswordForm from '../../../features/auth/components/forgotPasswordForm/ForgotPasswordForm';

const ForgotPassword = () => (
  <div className="page-container centered-content">
    <ForgotPasswordForm />
  </div>
);

export default ForgotPassword;
